<div class="success-message-container">
  <div class="card">
    <p>
      Your request has been successfully submitted. An email acknowledgment will
      be sent to<b>
        {{ userEmail }}
      </b>
      .
      <br />
      <!-- Please <a (click)="goToBuyerDetails()">click here</a> to convert another
      receipt into an invoice. -->
    </p>
  </div>
</div>